module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-zh-TW.add1d672.jpg";